import { EditorAction } from "../../../actions/editor";
import { JupyterAction, JupyterActionKey } from "../../../actions/jupyter";
import { JupyterStatus } from "../../../types";

export const status = (
  state: JupyterStatus = JupyterStatus.IDLE,
  action: JupyterAction | EditorAction
) => {
  switch (action.type) {
    case JupyterActionKey.SET_JUPYTER_STATE:
      return action.payload.jupyter.status;
    case JupyterActionKey.SET_JUPYTER_STATUS:
      // If the Kernel is running and a new state flows in that is not DISCONNECTED, don't update.
      if (
        state === JupyterStatus.RUNNING &&
        action.payload.status !== JupyterStatus.DISCONNECTED
      ) {
        return state;
      }
      return action.payload.status;
    default:
      return state;
  }
};
